import React from "react";
import PropTypes from "prop-types";
import MatchingText from "../../../component/matchingText/MatchingText";
import "./SearchRecommendationItem.scss";

/**
 * 추천 검색어 아이템 컴포넌트
 * @param data 추천 검색어 데이터 (text 포함)
 * @param searchQuery 검색어
 * @param onClick 검색 실행 함수
 * @returns {JSX.Element}
 */
const SearchRecommendationItem = ({ data, searchQuery, onClick }) => {
  return (
    <div
      className="search-recommendation-item"
      onClick={() => onClick(data.text)}
    >
      <svg className="search-recommendation-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <div className="search-recommendation-text">
        <MatchingText fullText={data.text} matchText={searchQuery} />
      </div>
    </div>
  );
};

SearchRecommendationItem.propTypes = {
  data: PropTypes.shape({
    text: PropTypes.string.isRequired,
  }).isRequired,
  searchQuery: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

SearchRecommendationItem.displayName = "SearchRecommendationItem";

export default React.memo(SearchRecommendationItem);
